import React from "react";
import SectionCard from "./SectionCard";
import { Input, PhotoInput, Textarea } from "./Fields";

export default function AboutSection({ form, onChange, onOpenLibrary }) {
  return (
    <SectionCard
      title='Section "À propos"'
      description="Bloc de présentation de la commune affiché sur la page d’accueil."
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Input
          label='Titre "À propos"'
          name="titre_about"
          value={form.titre_about}
          onChange={onChange}
          placeholder="Ex : À propos de notre commune"
        />

        <PhotoInput
          label='Photo "À propos"'
          name="photoURL_about"
          value={form.photoURL_about}
          onChange={onChange}
          onOpenLibrary={() => onOpenLibrary("photoURL_about")}
          previewMode="contain"
        />

        <div className="md:col-span-2">
          <Textarea
            label="Description"
            name="description_about"
            value={form.description_about}
            onChange={onChange}
            rows={7}
            placeholder="Texte de présentation de la commune, du territoire, des services, etc."
            hint="Cette description est importante pour le référencement naturel du site."
          />
        </div>
      </div>
    </SectionCard>
  );
}